<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-navbar class="no-gutters">
        <b-col lg="7" md="12" class="mx-auto no-gutters">
            <b-navbar class="no-gutters">
                <!-- Logo in center -->
                <b-navbar-brand class="top-logo-container" @click="backToMain">
                    <img class="mx-auto top-logo" src="../assets/logo.png" alt="fair-logo"/>
                </b-navbar-brand>
                <b-navbar-nav>
                    <b-nav-item class="left-nav-item" v-if="$store.state.token"  lef href="#"
                    >
                        <b-button class="top-bar-search-btn" @click.stop="backToMain">
                            <font-awesome-icon icon="home" size="lg"/>
                            <span class="menu-text-under d-none d-md-block">{{ $t('common.home') }}</span>
                        </b-button>
                    </b-nav-item>
                    <b-nav-item v-else href="#"
                                @click.stop="$emit('onSignInClicked')">
                        <font-awesome-icon icon="user"/>
                        <span class="menu-text">{{ $t('login.login') }}</span>
                    </b-nav-item>
                </b-navbar-nav>

                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">
                    <b-nav-item-dropdown right no-caret  v-if="$store.state.token">
                        <template v-slot:button-content>
                            <font-awesome-icon icon="bars"/>
                        </template>
                        <b-dropdown-item href="#" @click.stop="$emit('showOrganizations')">
                            {{ $t('page.organizations')}}
                        </b-dropdown-item>
                        <b-dropdown-item href="#" @click.stop="$emit('showUsers')">
                            {{ $t('page.users')}}
                        </b-dropdown-item>
                        <b-dropdown-divider/>
                        <b-dropdown-item href="#" @click.stop="logout">
                            {{ $t('common.logout') }}
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-navbar>
        </b-col>
    </b-navbar>
</template>

<script>

    export default {
        name: "admin-top-bar",
        mixins: [],
        methods: {
            logout: function () {
                this.$store.commit('storeToken', null)
            },
            backToMain: function () {
                this.$router.push({name: 'main-view'})
            },
        }
    }
</script>

<style scoped>

</style>
